import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SpanMaintenanceModalComponent } from './span-maintenance-modal.component';

@Injectable()
export class SpanMaintenanceModalService {

    constructor(private readonly dialog: MatDialog) { }

    showModal() {
        let dialogRef: MatDialogRef<SpanMaintenanceModalComponent>;

        dialogRef = this.dialog.open(
            SpanMaintenanceModalComponent,
            {
                disableClose: true,
                panelClass: 'tprecm-modal-panel',
                height: '94vh',
            }
        );

        return dialogRef;
    }
}
